import './CountersGroup.css';
import React, { useState } from 'react';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
import { ReactComponent as IconMinus } from '../../../resources/icons/icon-minus-round.svg';
import { ReactComponent as IconPlus } from '../../../resources/icons/icon-plus-round.svg';
const Counter = _ref => {
  let {
    onChange,
    value,
    description,
    title,
    maxLength,
    minLenth,
    setError,
    infantsError,
    totalError,
    infantsCounter
  } = _ref;
  const counterHandler = add => {
    if (value >= maxLength && add) {
      setError(infantsCounter ? infantsError : totalError);
      return;
    }
    if (value <= minLenth && !add) return;
    if (onChange) {
      setError('');
      onChange(value + (add ? +1 : -1));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "counter-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-title"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "counter-item__header"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "counter-item__intro"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-btn"
  }, /*#__PURE__*/React.createElement("button", {
    className: `counter-item__btn counter-item__btn--minus ${value === minLenth ? 'counter-item__btn--disabled' : ''}`,
    onClick: () => {
      counterHandler(false);
    }
  }, /*#__PURE__*/React.createElement(IconMinus, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-value"
  }, value), /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-btn"
  }, /*#__PURE__*/React.createElement("button", {
    className: `counter-item__btn counter-item__btn--plus ${value === maxLength ? 'counter-item__btn--disabled' : ''}`,
    onClick: () => {
      counterHandler(true);
    }
  }, /*#__PURE__*/React.createElement(IconPlus, {
    className: "icon"
  }))));
};
const CountersGroup = _ref2 => {
  let {
    adults,
    setAdults,
    childrens,
    setChildrens,
    infants,
    setInfants,
    title,
    intro,
    textAdults,
    descriptionAdult,
    textChildren,
    descriptionChildren,
    textInfants,
    descriptionInfants,
    textCabinClass,
    textEconomy,
    textBusiness,
    textAmountValidationInfants,
    textAmountValidationTotal,
    economyCabinClass,
    setEconomyCabinClass,
    textClear,
    textSave,
    rtl,
    close,
    saveAction
  } = _ref2;
  const [error, setError] = useState('');
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-close d-none d-md-block",
    onClick: () => {
      close();
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: () => {
      close();
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, title), !(adults === 1 && childrens === 0 && infants === 0 && economyCabinClass) && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: () => {
      setAdults(1);
      setChildrens(0);
      setInfants(0);
      setEconomyCabinClass(true);
      setError('');
    }
  }, textClear)), /*#__PURE__*/React.createElement("div", {
    className: "counters-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "counters-items"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "d-none d-md-block counters-items__header"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "counters-items__intro"
  }, intro), /*#__PURE__*/React.createElement(Counter, {
    onChange: setAdults,
    value: adults,
    description: descriptionAdult,
    title: textAdults,
    maxLength: 9 - childrens,
    minLenth: 1,
    setError: setError,
    infantsError: textAmountValidationInfants,
    totalError: textAmountValidationTotal
  }), /*#__PURE__*/React.createElement(Counter, {
    onChange: setChildrens,
    value: childrens,
    description: descriptionChildren,
    title: textChildren,
    maxLength: 9 - adults,
    minLenth: 0,
    setError: setError,
    infantsError: textAmountValidationInfants,
    totalError: textAmountValidationTotal
  }), /*#__PURE__*/React.createElement(Counter, {
    onChange: setInfants,
    value: infants,
    description: descriptionInfants,
    title: textInfants,
    maxLength: adults,
    minLenth: 0,
    setError: setError,
    infantsError: textAmountValidationInfants,
    totalError: textAmountValidationTotal,
    infantsCounter: true
  })), error ? /*#__PURE__*/React.createElement("div", {
    className: "counters-error-message-wrapper"
  }, error) : null, /*#__PURE__*/React.createElement("div", {
    className: "counters-class-selector"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "counters-class-selector__header"
  }, textCabinClass), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "radiobutton-item"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "class-type-economy",
    name: "class-type",
    checked: economyCabinClass,
    onChange: () => {
      setEconomyCabinClass(true);
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "radiobutton-item__label",
    htmlFor: "class-type-economy"
  }, /*#__PURE__*/React.createElement("span", {
    className: "radiobutton-item__label-text"
  }, textEconomy))), /*#__PURE__*/React.createElement("div", {
    className: "radiobutton-item"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "class-type-business",
    name: "class-type",
    checked: !economyCabinClass,
    onChange: () => {
      setEconomyCabinClass(false);
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "radiobutton-item__label",
    htmlFor: "class-type-business"
  }, /*#__PURE__*/React.createElement("span", {
    className: "radiobutton-item__label-text"
  }, textBusiness)))))), /*#__PURE__*/React.createElement("div", {
    className: "counters-footer d-md-none"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: () => {
      close();
      saveAction();
    }
  }, textSave)));
};
const commonStyles = "c2tb7xx";
const ltrStyles = "ls0jwjp";
const rtlStyles = "r1712nah";
const StyledWrapper = _ref3 => {
  let {
    rtl,
    children
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `
  amount-dropdown
  ${commonStyles}
  ${rtl ? rtlStyles : ltrStyles}
`
  }, children);
};
export default CountersGroup;